/**
 * Normalizes form and API values before they participate in arithmetic.
 * HTML number inputs and older API payloads can still provide numeric strings.
 */
export function numberValue(value: unknown): number {
  const number = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(number) ? number : 0;
}
